import { Commercial } from "./commercials.model";
import { Locality } from "./localities.model";
import { TypeTiers } from "./type-tiers.model";
import { TypeCustomer } from "./type-customers.model";

export class Tiers {
  id: number;
  name: string;
  cin: string;
  phone1: string;
  phone2: string;
  fax: string;
  email: string;
  rib: string;
  patent: string;
  createAt: Date;
  typeTiers: TypeTiers;
  typeCustomer?: TypeCustomer;
  locality: Locality;
  commercials: Commercial[];

  raisonSociale?: string;
  ice?: string;
  website?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;

  prospect?: boolean;
  active?: boolean;

  constructor() {
    this.typeCustomer = new TypeCustomer();
    this.typeTiers = new TypeTiers();
    this.locality = new Locality();
  }
}

export class TiersForm {
  id: number;
  name: string;
  cin: string;
  phone1: string;
  phone2: string;
  fax: string;
  email: string;
  rib: string;
  patent: string;
  createAt: Date;
  typeTiers: number;
  locality: Locality;
  commercials: number[];

  raisonSociale?: string;
  ice?: string;
  website?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;

  prospect?: boolean;
  active?: boolean;

  constructor() {
    this.commercials = [];
    this.locality = new Locality();
  }
}
